// extracted by mini-css-extract-plugin
export default {"pageSectionWrapper":"PageSection_pageSectionWrapper__hbBVR","pageSection":"PageSection_pageSection__EYt2p","pageSection-background":"PageSection_pageSection-background__5a-sd"};